import React, { Component } from "react";
import Carousel from "react-bootstrap/Carousel";
import { ENTITY_PLURAL_LABEL } from "../../Helpers/Labels/EntityLabel";
import Scrollable from "../../Shared/Edit/Scrollable";
class SolutionDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            integration: "",
        };
    }

    render() {
        return (
            <Scrollable>
                <div className="my-3 mx-2">
                    <div className="align-self-start">
                        <button
                            className="btn btn-secondary"
                            onClick={this.props.onBack}
                        >
                            <i className="mx-1 far fa-long-arrow-left"></i>
                            Back to App Library
                        </button>
                    </div>

                    <div className="row m-0 my-4">
                        <div className="col-6 ps-0">
                            <div className="my-2 ms-0 page-header">
                                <h2>{this.props.solution.name}</h2>
                            </div>
                        </div>

                        {
                            this.props.userRole !== "App Participant" ?
                                <div className="col-6 text-end">
                                    {
                                        this.props.isShowFromRuntime ?
                                            <button onClick={() => this.props.onCreate(this.props.solution)} className="mb-2 btn btn-primary">
                                                <i className="me-1 fas fa-down"></i>
                                                Install
                                            </button>
                                            :
                                            <button
                                                onClick={() => this.props.UseSolutionTemplate(this.props.solution)}
                                                className="mb-1 btn btn-primary">
                                                <i className="me-1 fas fa-arrow-alt-right"></i>
                                                Use App
                                            </button>
                                    }
                                </div>
                                :
                                <div className="col-6 text-end"></div>
                        }

                        <div className="col-6 ps-0 py-2">
                            {this.props.solution.isSuperApp === true && (
                                <span className="px-3 py-2 super-app">
                                    <i className="me-1 fas fa-rocket"></i>SUPER APP
                                </span>
                            )}

                            {this.props.solution.isFeaturedApp === true && (
                                <span className="px-3 py-2 mx-1 featured-app">
                                    <i className="me-1 fas fa-rocket"></i>FEATURED APP
                                </span>
                            )}
                        </div>

                        {
                            this.props.userRole !== "App Participant" ?
                                <div className="col-6 text-end txt-opacity font-size-1">
                                    You can easily customize your app
                                </div> :
                                <div className="col-6 text-end txt-opacity font-size-1"></div>
                        }

                        <div className="col-12 my-3 ps-0">
                            {this.props.solution.tags &&
                                this.props.solution.tags
                                    .filter((o) => o.length > 0)
                                    .map((tag) => (
                                        <span className="p-2 px-3 me-1 tag">
                                            {tag}
                                        </span>
                                    ))}
                        </div>
                    </div>

                    <div className="m-0 row">
                        <div className="ps-0 col-12">
                            <div className="pb-2 big border-bottom font-weight-2 font-size-4 page-header">Overview</div>
                            {this.props.solution.description && (
                                <div className="py-3 text-justify txt-opacity font-size-1">
                                    {this.props.solution.description}
                                </div>
                            )}
                            <div className="m-0 row">
                                <div className="col ps-0">
                                    <div className="py-2 big border-bottom page-header font-size-4">
                                        Portals
                                    </div>

                                    {this.props.solution.Portals &&
                                        this.props.solution.Portals.slice(0, 5).map(
                                            (portal, index) => (
                                                <div className="py-2 font-size-1 txt-opacity">
                                                    <i
                                                        className={
                                                            portal.Icon + " fa-fw me-2"
                                                        }
                                                    ></i>
                                                    {portal.portalName}
                                                </div>
                                            )
                                        )}
                                    {this.props.solution.Portals &&
                                        this.props.solution.Portals.length > 5 && (
                                            <div className="py-2 font-size-1 txt-opacity">
                                                <i className="me-2 fa fa-plus fa-fw"></i>
                                                more
                                            </div>
                                        )}
                                </div>
                                <div className="col">
                                    <div className="py-2 big border-bottom page-header font-size-4">
                                        {ENTITY_PLURAL_LABEL}
                                    </div>
                                    {this.props.solution.Entities &&
                                        this.props.solution.Entities.slice(
                                            0,
                                            8
                                        ).map((entity, index) => (
                                            <div className="py-2 font-size-1 txt-opacity">
                                                <i
                                                    className={
                                                        entity.Icon + " fa-fw me-2"
                                                    }
                                                ></i>
                                                {entity.name}
                                            </div>
                                        ))}
                                    {this.props.solution.Entities &&
                                        this.props.solution.Entities.length > 8 && (
                                            <div className="py-2 font-size-1 txt-opacity">
                                                <i className="me-2 fa fa-plus fa-fw"></i>
                                                more
                                            </div>
                                        )}
                                </div>
                                <div className="col">
                                    <div className="py-2 big border-bottom page-header font-size-4">
                                        Features
                                    </div>
                                    <div className="font-size-1 txt-opacity">
                                        {this.props.solution.hasTableFeature === true && <div className="py-2"><i className="far fa-table fa-fw me-2 "></i>Table</div>}
                                        {this.props.solution.hasCardsFeature === true && <div className="py-2"><i className="far fa-credit-card-blank fa-fw me-2"></i>Cards</div>}
                                        {this.props.solution.hasCalendarFeature === true && <div className="py-2"><i className="far fa-calendar fa-fw me-2"></i>Calendar</div>}
                                        {this.props.solution.hasSplitViewFeature === true && <div className="py-2"><i className="far fa-columns fa-fw me-2"></i>Split View</div>}
                                        {this.props.solution.hasListsFeature === true && <div className="py-2"><i className="far fa-list-ul fa-fw me-2"></i>Lists</div>}
                                        {this.props.solution.hasChartsFeature === true && <div className="py-2"><i className="far fa-chart-bar fa-fw me-2"></i>Charts</div>}
                                        {this.props.solution.hasReportingFeature === true && <div className="py-2"><i className="far fa-file fa-fw me-2"></i>Reporting</div>}
                                        {this.props.solution.hasDashboardFeature === true && <div className="py-2"><i className="far fa-dashboard fa-fw me-2"></i>Dashboard</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col ps-0">
                            <div className="py-2 mb-3 big border-bottom page-header font-size-4">
                                Screenshots
                            </div>
                            <div className="p-1Y">
                                {this.props.solution.SlideshowImages.length > 0 ? (
                                    <>
                                        <Carousel variant="dark">
                                            {this.props.solution.SlideshowImages.map(
                                                (item) => (
                                                    <Carousel.Item>
                                                        <div className="justify-content-center d-flex">
                                                            <img
                                                                alt=""
                                                                className="w-75"
                                                                src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_CONTAINER}/${this.props.solution.organizationId}/${this.props.solution._id}/ProjectImages/${item}`}
                                                            />
                                                        </div>
                                                        <Carousel.Caption></Carousel.Caption>
                                                    </Carousel.Item>
                                                )
                                            )}
                                        </Carousel>
                                    </>
                                ) : (
                                    <span>Image not available to display</span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Scrollable >
        );
    }
}

export default SolutionDetail;
